import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosBasePostQuery } from "@/redux/api/fetchBaseQueryHelper";

export const login = createAsyncThunk("auth/login", async (data, thunkAPI) => {
	try {
		const response = await axiosBasePostQuery({
			url: "/users/login",
			data,
		});
		return response.data;
	} catch (err) {
		return thunkAPI.rejectWithValue(err.response.data.errors);
	}
});
